<template>
  <div class="account-binding">
    <a-list
      itemLayout="horizontal"
      :dataSource="normalData"
    >
      <h2 slot="header">普通绑定</h2>
      <a-list-item
        slot="renderItem"
        slot-scope="item"
      >
        <a-list-item-meta :description="item.description">
          <a-icon
            :class="
              [
                'account-binding__icon',
                `${item.status === 1 ? 'account-binding__icon--binding' : ''}`
              ].join(' ')
            "
            slot="avatar"
            :type="item.icon"
          />
          <div slot="title">{{ item.title }}</div>
        </a-list-item-meta>
        <a
          v-if="item.status === 1"
          slot="actions"
        >修改</a>
        <a
          v-else
          slot="actions"
        >绑定</a>
      </a-list-item>
    </a-list>
    <a-list
      itemLayout="horizontal"
      :dataSource="thirdData"
    >
      <h2 slot="header">第三方绑定</h2>
      <a-list-item
        slot="renderItem"
        slot-scope="item"
      >
        <a-list-item-meta :description="item.description">
          <a-icon
            :class="
              [
                'account-binding__icon',
                `${item.status === 1 ? 'account-binding__icon--binding' : ''}`
              ].join(' ')
            "
            slot="avatar"
            :type="item.icon"
          />
          <div slot="title">{{ item.title }}</div>
        </a-list-item-meta>
        <a
          v-if="item.status === 1"
          slot="actions"
        >修改</a>
        <a
          v-else
          slot="actions"
        >绑定</a>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      normalData: [
        {
          icon: 'phone',
          title: '手机号码',
          description: '已绑定手机号码：1234567890',
          status: 1,
        },
        {
          icon: 'mail',
          title: '邮箱账号',
          description: '未绑定邮箱账号',
          status: 2,
        },
      ],
      thirdData: [
        {
          icon: 'github',
          title: 'github账号',
          description: '已绑定github账号：sanweijia',
          status: 1,
        },
        {
          icon: 'wechat',
          title: '微信账号',
          description: '未绑定微信账号',
          status: 2,
        },
        {
          icon: 'qq',
          title: 'QQ账号',
          description: '未绑定QQ账号',
          status: 2,
        },
        {
          icon: 'zhihu',
          title: '知乎账号',
          description: '未绑定知乎账号',
          status: 2,
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.account-binding {
  height: 100%;
  padding: @padding-lg;
  background: white;
  border-radius: @border-radius-base;
  box-shadow: @box-shadow-base;
  &__icon {
    padding: 12px;
    border-radius: 50%;
    color: white;
    font-size: 24px;
    background: @gray-6;
    &--binding {
      opacity: 1;
      background: @primary-color;
    }
  }
}
</style>
